import { unitsForVocation } from './vocations.js';

// Compatibility export for older imports. The active game reads the selected
// vocation from vocations.js, so this remains the Army view only.
export const UNITS = unitsForVocation('army');

export const RANKS = [
  { name: 'Recruit', short: 'REC', threshold: 0 },
  { name: 'Private', short: 'PTE', threshold: 1e3 },
  { name: 'Lance Corporal', short: 'LCP', threshold: 1e4 },
  { name: 'Corporal', short: 'CPL', threshold: 1e5 },
  { name: 'Corporal First Class', short: 'CFC', threshold: 1e6 },
  { name: 'Third Sergeant', short: '3SG', threshold: 1e7 },
  { name: 'Second Sergeant', short: '2SG', threshold: 1e8 },
  { name: 'First Sergeant', short: '1SG', threshold: 1e9 },
  { name: 'Staff Sergeant', short: 'SSG', threshold: 1e10 },
  { name: 'Master Sergeant', short: 'MSG', threshold: 1e11 },
  { name: 'Second Lieutenant', short: '2LT', threshold: 1e12 },
  { name: 'Lieutenant', short: 'LTA', threshold: 1e13 },
  { name: 'Captain', short: 'CPT', threshold: 1e14 },
  { name: 'Major', short: 'MAJ', threshold: 1e15 },
  { name: 'Lieutenant Colonel', short: 'LTC', threshold: 1e17 },
  { name: 'Colonel', short: 'COL', threshold: 1e19 },
  { name: 'Brigadier-General', short: 'BG', threshold: 1e22 },
  { name: 'Major-General', short: 'MG', threshold: 1e26 },
  { name: 'Lieutenant-General', short: 'LG', threshold: 1e30 },
];
